import React from 'react';
import {Button, TextButton} from 'wix-ui-tpa';

type SuggestionActionsProps = React.HTMLAttributes<HTMLDivElement> & {
  isMobile: boolean;
};

const styles: Record<string, React.CSSProperties> = {
  suggestionActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%',
  },
  switchButton: {
    backgroundColor: 'black',
    color: 'white',
    height: 52,
    minHeight: 52,
    boxSizing: 'border-box',
    padding: '0 16px',
    whiteSpace: 'nowrap',
  },
  switchButtonContent: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 10,
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  keepButton: {
    color: 'black',
  },
};

export const SuggestionActions = ({isMobile, style, ...props}: SuggestionActionsProps) => (
  <div
    {...props}
    style={{
      ...styles.suggestionActions,
      flexDirection: isMobile ? 'column' : 'row',
      gap: isMobile ? 12 : 16,
      ...style,
    }}
  />
);

export const SwitchButton = ({style, ...props}: React.ComponentProps<typeof Button>) => (
  <Button {...props} style={{...styles.switchButton, ...style}} />
);

export const SwitchButtonContent = ({style, ...props}: React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...props} style={{...styles.switchButtonContent, ...style}} />
);

export const KeepButton = ({style, ...props}: React.ComponentProps<typeof TextButton>) => (
  <TextButton {...props} style={{...styles.keepButton, ...style}} />
);
